import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { sumSt52Quota } from '@/api/api';
export default {
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    top: {
      type: String,
      default: '0px'
    },
    left: {
      type: String,
      default: '0px'
    },
    siteId: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    this.getData('52');
  },
  methods: {
    getData: function getData(st) {
      var _this = this;

      var p = Promise.all([this.getSumSt52Quota(0), this.getSumSt52Quota(2)]);
      p.then(function (data) {
        var res = data[0];
        var res2 = data[1];

        if (res && res2) {
          // let data1
          // if(res.result.waterInlet && res.result.electConsum){
          //   data1=res.result.waterInlet !=0 ? res.result.electConsum / res.result.waterInlet : 0
          // }else{
          //   data1=0
          // }
          // let data2
          // if(res2.result.waterInlet && res2.result.electConsum){
          //   data2=res2.result.waterInlet !=0 ? res2.result.electConsum / res2.result.waterInlet : 0
          // }else{
          //   data2=0
          // }
          _this.initBarChart([{
            name: '今日进水总量',
            unit: 'm³',
            value: res.result.waterInlet ? res.result.waterInlet.toFixed(2) : 0
          }, {
            name: '进水总量日均',
            unit: 'm³',
            value: res2.result.waterInlet ? res2.result.waterInlet.toFixed(2) : 0
          }, {
            name: '今日出水总量',
            unit: 'm³',
            value: res.result.waterOutlet ? res.result.waterOutlet.toFixed(2) : 0
          }, {
            name: '出水总量日均',
            unit: 'm³',
            value: res2.result.waterOutlet ? res2.result.waterOutlet.toFixed(2) : 0
          } // , {
          //   name: '今日用电总量',
          //   unit: 'kW·h',
          //   value: res.result.electConsum ? res.result.electConsum.toFixed(2) : 0
          // }, {
          //   name: '用电总量日均',
          //   unit: 'kW·h',
          //   value: res2.result.electConsum ? res2.result.electConsum.toFixed(2) : 0
          // },  {
          //   name: '今日吨水能耗',
          //   unit: 'kW/T',
          //   value: data1 ? data1.toFixed(2) : 0
          // }, {
          //   name: '吨水能耗日均',
          //   unit: 'kW/T',
          //   value: data2 ? data2.toFixed(2) : 0
          // }
          ]);
        }
      });
    },
    getSumSt52Quota: function getSumSt52Quota(dateType) {
      return sumSt52Quota({
        scope: 1,
        scopeId: this.siteId,
        dateType: dateType
      }).then(function (res) {
        if (res.success) {
          return res;
        } else {
          return {};
        }
      });
    },
    initBarChart: function initBarChart(data) {
      //	趋势图
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      var mainData = data;

      function createSeries(mainData) {
        var result = [];
        var colors = ['#aaaaff', '#aaaaff', '#2ec7c9', '#2ec7c9', '#5ab1ef', '#5ab1ef', '#f16415', '#f16415'];
        var insideLabel = {
          normal: {
            position: 'center',
            formatter: function formatter(params) {
              if (params.name == "其他") return "";
              return '\n\n\n\n\n' + params.value + '\n' + params.data.unit + '\n\n\n\n' + params.name + (params.name != '同比' && params.name != '环比' ? '' : '                 ');
            },
            textStyle: {
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: 12
            }
          }
        };
        var outsideLabel = {
          normal: {
            show: false
          }
        };
        var itemOthers = {
          normal: {
            color: '#ccc'
          }
        };

        for (var i = 0; i < mainData.length; i++) {
          result.push({
            type: 'pie',
            center: [i < 4 ? i * 25 + 15 + '%' : (i - 4) * 25 + 15 + '%', i < 4 ? '20%' : '65%'],
            radius: ['25%', '35%'],
            label: insideLabel,
            itemStyle: {
              color: colors[i]
            },
            data: [{
              name: '其他',
              value: mainData[i].value,
              itemStyle: itemOthers,
              unit: mainData[i].unit
            }, {
              name: mainData[i].name,
              value: mainData[i].value,
              unit: mainData[i].unit
            }]
          });
        }

        return result;
      }

      var option = {
        tooltip: {
          show: true,
          formatter: function formatter(params) {
            if (params.name == "其他") return "";
            return params.marker + params.name + ':' + params.value + params.data.unit;
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: {
              show: true,
              readOnly: true
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        series: createSeries(mainData)
      };
      myChart.setOption(option, true);
      window.addEventListener('resize', function () {
        myChart.resize();
        console.log('宽：', myChart.getWidth());
        option = {
          tooltip: {
            show: true,
            formatter: function formatter(params) {
              if (params.name == "其他") return "";
              return params.marker + params.name + ':' + params.value + params.data.unit;
            }
          },
          toolbox: {
            show: false,
            feature: {
              dataView: {
                show: true,
                readOnly: true
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          series: createSeries(mainData)
        };
        myChart.setOption(option, true);
      });
    }
  }
};